// Func = limiting Scope for this file
let lastScrollTop = 0;
let timeout;
let subtleParallaxEvents = [];
let deviceWidth = window.innerWidth;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}



function subtleParallax(el,index){

	let parallaxFunction = () => {
		let depth = el.dataset.depth;
		let move = window.pageYOffset * depth;
		el.style.transform = `translateY(${move}px)`;
		
	}

	subtleParallaxEvents[index] = parallaxFunction;
	window.addEventListener('scroll', subtleParallaxEvents[index]);
} 

function resizeWindow(){
	deviceWidth = window.innerWidth;
}

//
(function(){

	let mainGallery = new LBX('.js-full-lbx', {});
	mainGallery.fullScreen = true;
	
	window.onload = function() {
		if(document.querySelector('.hero')) {
			scrollW();
			window.addEventListener('scroll', function(){
				scrollW();
				
			})
		} else {
			document.querySelector('header').classList.add('down');
		}


	};

	
	window.addEventListener('resize', () => {
		resizeWindow();
		
	});

	// FORM focus animation
	if(document.querySelectorAll('.form-module__field:not(.gdpr)').length > 0){
		document.querySelectorAll('.form-module__field:not(.gdpr)').forEach(field => {
			const input = field.querySelector('input, textarea, select');
			if (input) {
				input.addEventListener('focus', () => field.classList.add('moved'));
			}
		})
	}
	if(document.querySelectorAll('#email-signup .field:not(.gdpr)').length > 0){
		document.querySelectorAll('#email-signup .field:not(.gdpr)').forEach(field => {
			const input = field.querySelector('input, textarea, select');
			if (input) {
				input.addEventListener('focus', () => field.classList.add('moved'));
			}
		})
	}

	if(document.querySelector('.form-module__field.tel input[type="tel"]')){
		document.querySelectorAll('.form-module__field.tel input[type="tel"]').forEach((input)=>{
			input.addEventListener('input', (e) => {
				let valueTel = e.target.value;
				valueTel = valueTel.replace(/[^0-9+]/g, '');

				if (valueTel.lastIndexOf('+') > 0) {
					const initialPlus = valueTel.startsWith('+');
					valueTel = (initialPlus ? '+' : '') + valueTel.replace(/\+/g, '');
				}
				e.target.value = valueTel;
			});
		})
	}



    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	//Links that open the menus:
	if(document.querySelectorAll('.js-go-to-link').length > 0){
		document.querySelectorAll('.js-go-to-link').forEach(link => {
			link.addEventListener('click', (e) => {
				e.preventDefault();
				let linkTarget = link.getAttribute('href');
				
				if(document.querySelector(`${linkTarget}`)){
					document.querySelector(`${linkTarget}`).scrollIntoView({ behavior: 'smooth' });
				}
			})
		})
	}

	// UGH highlights mobile accordion ew!
	if(document.querySelectorAll('.js-accordion-trigger').length > 0){
		document.querySelectorAll('.js-accordion-trigger').forEach(trigger => {
			trigger.addEventListener('click', () => {
				if(deviceWidth < 900){
					trigger.parentElement.classList.toggle('open');
				}
				
			})
		})

	}

	//subtle parallax animation
	if(document.querySelectorAll('.js-media-observer').length > 0){


		function subtleParallax(el,index){
			let elementAsset = el.querySelector('img') || el.querySelector('video');
			let speed = el.dataset.speed ? parseInt(el.dataset.speed) : 1;
			let direction = el.dataset.direction ? parseInt(el.dataset.direction) : 1;
			if (!elementAsset) return;

    		let ticking = false;
			let parallaxFunction = () => {
				if (!ticking) {
					window.requestAnimationFrame(() => {
						// 1. Get element position relative to viewport
						const rect = el.getBoundingClientRect();
						const viewportHeight = window.innerHeight;

					
						let progress = (viewportHeight - rect.top) / (viewportHeight + rect.height);
						progress = Math.max(0, Math.min(speed, progress));

						const maxMove = 18 * speed; 
						const move = (progress * maxMove);

						elementAsset.style.transform = `translateY(${direction * move}%)`;
						ticking = false;
					});
					ticking = true;
				}
				
			}

			subtleParallaxEvents[index] = parallaxFunction;
			window.addEventListener('scroll', parallaxFunction);
		} 


		let observerOptions = {
			root: null,
			rootMargin: '0px',
			threshold: 0.4
		}

		const assetObserver = new IntersectionObserver((entries, observer) => {
			entries.forEach((entry) => {
				let realIndex = Array.from(document.querySelectorAll('.js-media-observer')).indexOf(entry.target);
				
				if (entry.isIntersecting) {
					entry.target.classList.add('in-viewport');
					subtleParallax(entry.target,realIndex);

				} else {
					entry.target.classList.remove('in-viewport');
					window.removeEventListener('scroll', subtleParallaxEvents[realIndex]);
				}
				});
			}, {
			observerOptions
		});
		document.querySelectorAll('.js-media-observer').forEach(el => assetObserver.observe(el));
	}

	//HEADER TABBING
// Burger Menu
	const burgers = document.querySelectorAll('.js-burger-menu');
	const menuContainer = document.getElementById('burgerMenu');
	const closeContainer = document.querySelector('.js-menu-close');

	function openMenu() {
		menuContainer.removeAttribute('inert'); 
		menuContainer.classList.add('is-open');
		burgers.forEach(burger => burger.setAttribute('aria-expanded', 'true'));
		setTimeout(() => {
			const focusable = getFocusable();
			focusable[0].focus();
		}, 100);
	}

	function closeMenu() {
		menuContainer.classList.remove('is-open');
		menuContainer.setAttribute('inert', ''); 
		burgers.forEach(burger => burger.setAttribute('aria-expanded', 'false'));
		burgers.forEach(burger => burger.focus());
	}

	function getFocusable() {
		return [...menuContainer.querySelectorAll(
			'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
		)].filter(el => !el.disabled && !el.closest('[hidden]'));
	}

	// Focus trap — only works when menu is open
	menuContainer.addEventListener('keydown', (e) => {
		if (e.key !== 'Tab') return;
		if (!menuContainer.classList.contains('is-open')) return; 

		const focusable = getFocusable();
		const first = focusable[0];
		const last = focusable[focusable.length - 1];

		if (e.shiftKey) {
			if (document.activeElement === first) {
				e.preventDefault();
				last.focus();
			}
		} else {
			if (document.activeElement === last) {
				e.preventDefault();
				first.focus();
			}
		}
	});

	burgers.forEach(burger => {
		burger.addEventListener('click', () => {
			const isOpen = burger.getAttribute('aria-expanded') === 'true';
			isOpen ? closeMenu() : openMenu();
		});
	});

	closeContainer.addEventListener('click', () => closeMenu());

	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape') {
			burgers.forEach(burger => {
				if (burger.getAttribute('aria-expanded') === 'true') closeMenu();
			});
		}
	});
	

	//ADA menus tabbing
	tabsAndADA();

	// highlights tabbing
	if(document.querySelectorAll('.js-item-title').length > 0){
		document.querySelectorAll('.js-item-title').forEach( item => {
			item.addEventListener('click', () => {
				document.querySelectorAll('.js-item-title').forEach( item => item.classList.remove('is-active'));
				document.querySelectorAll('.js-highlights-item').forEach( item => item.classList.remove('is-visible'));
				document.querySelector(`[data-target="${item.dataset.title}"]`).classList.add('is-visible');
				item.classList.add('is-active');
			});
		});
		
		initHighlightsNavigation();
	}
	
	// highlights navigation buttons
	function initHighlightsNavigation() {
		const prevBtn = document.querySelector('.highlights-nav-prev');
		const nextBtn = document.querySelector('.highlights-nav-next');
		
		if(!prevBtn || !nextBtn) return;
		
		prevBtn.addEventListener('click', () => navigateHighlights('prev'));
		nextBtn.addEventListener('click', () => navigateHighlights('next'));
	}
	
	function navigateHighlights(direction) {
		const titles = Array.from(document.querySelectorAll('.js-item-title'));
		const activeIndex = titles.findIndex(item => item.classList.contains('is-active'));
		
		let newIndex;
		if(direction === 'prev') {
			newIndex = activeIndex > 0 ? activeIndex - 1 : titles.length - 1;
		} else {
			newIndex = activeIndex < titles.length - 1 ? activeIndex + 1 : 0;
		}
		
		titles[newIndex].click();
	}

	//portfolio 
	if(document.querySelectorAll('.js-hotel-trigger').length > 0){
		const hotelTriggers = document.querySelectorAll('.js-hotel-trigger');
		const hotels = document.querySelectorAll('.js-hotel');
		let toggle = window.innerWidth > 900 ? null : 0;

		function showHotels(trigger){
			document.querySelector('#portfolioList').classList.add('loading');
			hotelTriggers.forEach(t => t.classList.remove('is-active'));
			trigger.classList.toggle('is-active');
			let triggerTag = trigger.getAttribute('href').replace('#', '');
			hotels.forEach( hotel => {
				if(triggerTag == 'all'){
					hotel.classList.remove('hidden');
				} else {
					if(hotel.dataset.target.includes(triggerTag)){
						hotel.classList.remove('hidden');
					}else{
						hotel.classList.add('hidden');
					}
				}
			});
			document.querySelector('#portfolioList').scrollIntoView();
			setTimeout(() => {
				document.querySelector('#portfolioList').classList.remove('loading');
				
			}, 600);
		}
		function showList(toggle) {
			if(toggle === 0){
				document.querySelector('#portfolioFilter').classList.add('open');
			} else {
				document.querySelector('#portfolioFilter').classList.remove('open');
			}
		}

		hotelTriggers.forEach(trigger => {
			trigger.addEventListener('click', (e) => {
				e.preventDefault();
				if(toggle !== null){
					if(toggle === 0){
						showList(toggle);
						toggle = 1;
					} else {
						showList(toggle);
						showHotels(trigger);
						toggle = 0;
					}
				} else {
					showHotels(trigger)
				}
				
			});
			
		});
	}

})();

function tabsAndADA(){

	if(document.querySelectorAll('[role="tablist"]').length > 0 ){
		const tabList = document.querySelector('[role="tablist"]');

		const tabs = [...tabList.querySelectorAll('[role="tab"]')];
		const panels = tabs.map(tab =>
			document.getElementById(tab.getAttribute('aria-controls'))
		);

		function activateTab(index) {
			tabs.forEach((tab, i) => {
				const isActive = i === index;
				tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
				tab.setAttribute('tabindex', isActive ? '0' : '-1');
				tab.classList.toggle('is-active', isActive);
			});

			panels.forEach((panel, i) => {
				if (i === index) {
					panel.removeAttribute('hidden');
				} else {
					panel.setAttribute('hidden', '');
				}
			});
		}

		tabs.forEach((tab, index) => {
			
			tab.setAttribute('tabindex', tab.getAttribute('aria-selected') === 'true' ? '0' : '-1');

			tab.addEventListener('click', () => activateTab(index));

			tab.addEventListener('keydown', (e) => {
				let newIndex = index;

				switch (e.key) {
					case 'ArrowRight':
						newIndex = (index + 1) % tabs.length;
						break;
					case 'ArrowLeft':
						newIndex = (index - 1 + tabs.length) % tabs.length;
						break;
					case 'Home':
						newIndex = 0;
						break;
					case 'End':
						newIndex = tabs.length - 1;
						break;
					default:
						return;
				}

				e.preventDefault();
				activateTab(newIndex);
				tabs[newIndex].focus();
			});
		});

		// Initialization: hide all panels except the active one
		if(window.innerWidth > 980){
			panels.forEach((panel, i) => {
				if (tabs[i].getAttribute('aria-selected') !== 'true') {
					panel.setAttribute('hidden', '');
				}
			});
		}
		
	}
	if(document.querySelectorAll('.faq-trigger').length > 0){
		const triggers = Array.from(document.querySelectorAll('.faq-trigger'));
		triggers.forEach((trigger) => {
			trigger.addEventListener('click', () => {
				const expanded = trigger.getAttribute('aria-expanded') === 'true';
				const panel = document.getElementById(trigger.getAttribute('aria-controls'));
				trigger.setAttribute('aria-expanded', String(!expanded));
				panel.hidden = expanded;
				trigger.parentElement.classList.toggle('active');
			});

			trigger.addEventListener('keydown', (e) => {
				const i = triggers.indexOf(trigger);
				let next = i;
				switch (e.key) {
					case 'ArrowDown': next = (i + 1) % triggers.length; break;
					case 'ArrowUp':   next = (i - 1 + triggers.length) % triggers.length; break;
					case 'Home':      next = 0; break;
					case 'End':       next = triggers.length - 1; break;
					default: return;
				}
				e.preventDefault();
				triggers[next].focus();
			});
		});
	}
}

function scrollW(){
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if(!document.getElementById('header').classList.contains('down'))  {
			document.getElementById('header').classList.add('down');
			
		}
	} else {
		if(document.getElementById('header').classList.contains('down')) {
			document.getElementById('header').classList.remove('down');
			
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}